

















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import UCContactForm from '@shared/components/@organisms/UCContactForm/UCContactForm.vue';

import { transformContactFormProps } from './helpers';
import { ISBContactFormField } from './types';

export default defineComponent({
  name: 'StoryblokContactForm',
  components: { UCContactForm },
  props: {
    title: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_text: {
      type: String,
      default: 'Submit',
    },
    fields: {
      type: Array as PropType<ISBContactFormField[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Error,
      default: null,
    },
    response: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const transformedFields = computed(() => props.fields.map(transformContactFormProps));

    return {
      transformedFields,
    };
  },
});
